import { useState, useEffect } from 'react';
import api from '../api/axios';
import { useToastContext } from '../contexts/ToastContext';

export default function PromoScreen() {
  const [imageFile, setImageFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const toast = useToastContext();

  useEffect(() => {
    fetchPromoImage();
  }, []);

  const fetchPromoImage = async () => {
    try {
      const response = await api.get('/promo-popup');
      if (response.data.image_url) {
        setPreview(response.data.image_url);
      }
    } catch (error) {
      console.log('Belum ada gambar promo');
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!imageFile) {
      toast.warning('Silakan pilih gambar terlebih dahulu');
      return;
    }
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('image', imageFile);

      const response = await api.post('/promo-popup', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      
      console.log('Upload response:', response.data);
      
      if (response.data.success || response.data.data) {
        toast.success('Gambar promo berhasil disimpan!');
        setImageFile(null);
        // Wait a bit before fetching to ensure DB is updated
        setTimeout(() => {
          fetchPromoImage();
        }, 500);
      } else {
        toast.warning('Upload berhasil tapi tidak ada konfirmasi');
        fetchPromoImage();
      }
    } catch (error) {
      console.error('Error:', error);
      const errorMessage = error.response?.data?.message ||
        error.response?.data?.error ||
        (error.response?.data?.errors ?
          Object.values(error.response.data.errors).flat().join(', ') :
          error.message);
      toast.error('Gagal menyimpan gambar: ' + errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleRemove = async () => {
    setLoading(true);
    try {
      await api.delete('/promo-popup');
      setImageFile(null);
      setPreview(null);
      toast.success('Gambar promo berhasil dihapus!');
    } catch (error) {
      console.error('Error:', error);
      toast.error('Gagal menghapus gambar');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-6">Promo Screen - Upload Gambar</h1>

      <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow p-6 space-y-6">
        <div>
          <label className="block text-sm font-medium mb-2">Upload Gambar Promo</label>
          <p className="text-sm text-gray-500 mb-4">Pilih gambar yang akan ditampilkan sebagai popup promo</p>
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            className="w-full px-4 py-2 border rounded-lg"
          />
        </div>

        {preview && (
          <div>
            <label className="block text-sm font-medium mb-2">Preview Gambar</label>
            <div className="border rounded-lg p-4 bg-gray-50">
              <img
                src={preview}
                alt="Preview"
                className="max-w-full h-auto rounded-lg shadow-lg mx-auto"
                style={{ maxHeight: '500px' }}
              />
            </div>
          </div>
        )}

        <div className="flex gap-3">
          <button
            type="submit"
            disabled={loading}
            className="flex-1 bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 disabled:opacity-50"
          >
            {loading ? 'Menyimpan...' : 'Simpan Gambar'}
          </button>
          {preview && (
            <button
              type="button"
              onClick={handleRemove}
              disabled={loading}
              className="px-6 bg-red-600 text-white py-3 rounded-lg font-semibold hover:bg-red-700 disabled:opacity-50"
            >
              Hapus
            </button>
          )}
        </div>
      </form>
    </div>
  );
}
